module.exports = __webpack_public_path__ + "media/images/it/icons/youtube-e885158426c7f515c25d2df506cbd3e2.svg";